import {createGlobalStyle} from "styled-components";
import {
    BLACK, CHILEAN_FIRE,
    DARK_GREY, DARKER_GREY, DARKEST_GREY, LIGHT_GREY,
    MECURY,
    MINE_SHAFT,
    ORANGE,
    ORANGE_BLACK,
    ORANGE_PEEL,
    SINOPIA,
    WHITE
} from '../constants/colors'

export const GlobalStyles = createGlobalStyle`

    ::-webkit-scrollbar-track {
        background: ${(props) => props.theme.auth_body};
    }

    ::-webkit-scrollbar-thumb {
        background: ${(props) => props.theme.tertiary_color};
    }

    body {
        background-color: ${(props) => props.theme.body};
    }

    .auth_right_bg {
        background-color: ${(props) => props.theme.auth_body}
    }

    h1, h2, h3, h4, h5, h6, p, label, button {
        color: ${(props) => props.theme.text};
    }

    .title {
        color: ${(props) => props.theme.text};
    }

    p, span {
        color: ${(props) => props.theme.text};
    }

    label {
        color: ${(props) => props.theme.text};
    }

    button {
        color: ${(props) => props.theme.text};
    }
    
    .loader_background {
        background-color: ${(props) => props.theme.auth_body};
    }

    .button_primary {
        color: ${(props) => props.theme.text};
        background-color: ${(props) => props.theme.primary_color};
        border-collapse: ${(props) => props.theme.border};
        transition: background-color 0.5s ease;
    }

    .button_primary:hover {
        background-color: ${(props) => props.theme.secondary_color};
        transition: background-color 0.5s ease;
    }

    .button_primary:active {
        background-color: ${(props) => props.theme.tertiary_color};
        transition: background-color 0.5s ease;
    }

    .button_primary:focus {
        background-color: ${(props) => props.theme.quaternary_color};
        transition: background-color 0.5s ease;
    }

    .button_primary:disabled {
        background-color: ${(props) => props.theme.primary_color};
        transition: background-color 0.5s ease;
    }

    .button_secondary {
        color: ${(props) => props.theme.text};
        background-color: ${(props) => props.theme.secondary_color};
    }

    .button_secondary:hover {
        background-color: ${(props) => props.theme.primary_color};
        transition: background-color 0.5s ease;
    }

    .button_secondary:active {
        background-color: ${(props) => props.theme.tertiary_color};
        transition: background-color 0.5s ease;
    }

    .button_secondary:focus {
        background-color: ${(props) => props.theme.quaternary_color};
        transition: background-color 0.5s ease;
    }

    .button_secondary:disabled {
        background-color: ${(props) => props.theme.secondary_color};
        transition: background-color 0.5s ease;
    }

    .button_light {
        color: ${(props) => props.theme.auth_body};
        background-color: ${(props) => props.theme.border};
        border: 1px solid ${(props) => props.theme.transparent}
    }

    .button_light:hover {
        color: ${(props) => props.theme.text};
        background-color: ${(props) => props.theme.auth_body};
        border: 1px solid ${(props) => props.theme.border};
        transition: background-color 0.5s ease;
    }

    .button_dark {
        color: ${(props) => props.theme.text};
        background-color: ${(props) => props.theme.auth_body};
        border: 1px solid ${(props) => props.theme.transparent}
    }

    .button_dark.active {
        color: ${(props) => props.theme.auth_body};
        background-color: ${(props) => props.theme.border};
        border: 1px solid ${(props) => props.theme.transparent}
    }

    .button_dark.border_hover:hover {
        background-color: ${(props) => props.theme.auth_body};
        color: ${(props) => props.theme.text};
        border: 1px solid ${(props) => props.theme.border};
        transition: background-color 0.5s ease;
    }

    .button_dark:hover {
        background-color: ${(props) => props.theme.border};
        color: ${(props) => props.theme.auth_body};
        border: 1px solid ${(props) => props.theme.border};
        transition: background-color 0.5s ease;
    }

    .button_border {
        color: ${(props) => props.theme.text};
        background-color: ${(props) => props.theme.transparent};
        border: 1px solid ${(props) => props.theme.border};
    }
    
    .
    
    .button_border:hover {
        background-color: ${(props) => props.theme.border};
        color: ${(props) => props.theme.auth_body};
        border: 1px solid ${(props) => props.theme.border};
        transition: background-color 0.5s ease;
    }


    .button_border:active, .button_border.active {
        background-color: ${(props) => props.theme.border};
        color: ${(props) => props.theme.auth_body};
        border: 1px solid ${(props) => props.theme.border};
        transition: background-color 0.5s ease;
    }

    .button_border:focus {
        background-color: ${(props) => props.theme.border};
        color: ${(props) => props.theme.auth_body};
        border: 1px solid ${(props) => props.theme.border};
        transition: background-color 0.5s ease;
    }

    .button_border:disabled {
        background-color: ${(props) => props.theme.transparent};
        color: ${(props) => props.theme.auth_body};
        border: 1px solid ${(props) => props.theme.border};
        transition: background-color 0.5s ease;
    }
    
    .button_border.active .button_icon > * {
        color: ${(props) => props.theme.auth_body};
    }

    .button_border:hover .button_icon2 > * {
        color: ${(props) => props.theme.auth_body};
    }

    .button_border:active .button_icon2 > * {
        color: ${(props) => props.theme.auth_body};
    }

    .button_border:focus .button_icon2 > * {
        color: ${(props) => props.theme.auth_body};
    }
    
    .active .button_icon2 svg {
        color: ${(props) => props.theme.auth_body};
    }

    .button_icon2 svg {
        color: ${(props) => props.theme.text};
    }
    
    button.border_plain_primary {
        color: ${(props) => props.theme.primary_color};
        background-color: ${(props) => props.theme.transparent};
        border: 1px solid ${(props) => props.theme.primary_color};
    }
    
    button.border_plain_primary svg {
        color: ${(props) => props.theme.primary_color};
        fill: ${(props) => props.theme.primary_color};
        path: ${(props) => props.theme.primary_color};
    }
    
    button.border_plain_primary:hover {
        color: ${(props) => props.theme.text};
        background-color: ${(props) => props.theme.primary_color};
        border: 1px solid ${(props) => props.theme.primary_color};
    }
    
    button.border_plain_primary:active {
        color: ${(props) => props.theme.text};
        background-color: ${(props) => props.theme.primary_color}!important;
    }
    
    button.border_plain_primary.active {
        color: ${(props) => props.theme.text};
        background-color: ${(props) => props.theme.primary_color}!important;
    }

    .button_border.border_primary {
        color: ${(props) => props.theme.primary_color}!important;
        background-color: ${(props) => props.theme.transparent}!important;
        border: 1px solid ${(props) => props.theme.primary_color}!important;
    }
    
    .button_border.border_primary:hover {
        color: ${(props) => props.theme.text}!important;
        background-color: ${(props) => props.theme.primary_color}!important;
        border: 1px solid ${(props) => props.theme.primary_color}!important;
    }
    
    .button_border.border_primary:active {
        color: ${(props) => props.theme.text}!important;
        background-color: ${(props) => props.theme.primary_color}!important;
        border: 1px solid ${(props) => props.theme.primary_color}!important;
    }
    
    .button_border.border_primary:focus {
        color: ${(props) => props.theme.text}!important;
        background-color: ${(props) => props.theme.primary_color}!important;
        border: 1px solid ${(props) => props.theme.primary_color}!important;
    }
    
    .auth_form_group input {
        color: ${(props) => props.theme.text};
        border: 1px solid ${(props) => props.theme.auth_body};
        background-color: ${(props) => props.theme.auth_body};
    }
    .auth_form_group textarea {
        color: ${(props) => props.theme.text};
        border: 1px solid ${(props) => props.theme.auth_body};
        background-color: ${(props) => props.theme.auth_body};
    }
    .auth_form_group textarea:focus {
        border: 1px solid ${(props) => props.theme.border};
        background-color: ${(props) => props.theme.auth_body};
    }
    .auth_form_group textarea::placeholder {
        color: ${(props) => props.theme.darkest_grey};
        opacity: 0.8;
    }
    .auth_form_group .input_flag_wrapper {
        color: ${(props) => props.theme.text};
        border: 1px solid ${(props) => props.theme.auth_body};
        background-color: ${(props) => props.theme.auth_body};
    }
    .auth_form_group input::placeholder {
        color: ${(props) => props.theme.darkest_grey}!important;
    }
    .primary_form_group input {
        color: ${(props) => props.theme.text};
        border: 1px solid ${(props) => props.theme.auth_body};
        background-color: ${(props) => props.theme.auth_body};
    }
    .primary_form_group input:focus {
        border: 1px solid ${(props) => props.theme.auth_body};
        background-color: ${(props) => props.theme.auth_body};
    }
    .primary_form_group input::placeholder {
        color: ${(props) => props.theme.darkest_grey};
    }
    .primary_form_group textarea {
        color: ${(props) => props.theme.text};
        border: 1px solid ${(props) => props.theme.auth_body};
        background-color: ${(props) => props.theme.auth_body};
    }
    .primary_form_group textarea:focus {
        border: 1px solid ${(props) => props.theme.auth_body};
        background-color: ${(props) => props.theme.auth_body};
    }
    .primary_form_group textarea::placeholder {
        color: ${(props) => props.theme.input_background};
    }
    
    .search_form_group input {
        color: ${(props) => props.theme.text};
        //border: 1px solid ${(props) => props.theme.border};
        background-color: ${(props) => props.theme.darker_grey};
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        background-color: ${(props) => props.theme.input_background} !important;
        color: ${(props) => props.theme.text} !important;
    }

    input:-webkit-autofill {
        transition: all 5000s ease-in-out 0s;
    }

    .auth_form_group input:focus {
        border: 1px solid ${(props) => props.theme.border};
        //background-color: ${(props) => props.theme.input_background};
    }

    .auth_form_group input::placeholder {
        color: ${(props) => props.theme.text};
    }

    .muted_text {
        color: ${(props) => props.theme.text};
    }

    .divider_line {
        background-color: ${(props) => props.theme.darkest_grey};
    }

    .divider_text {
        color: ${(props) => props.theme.white};
    }

    .side_bar {
        background-color: ${(props) => props.theme.auth_body};
    }

    .side_bar_menu_item:hover {
        background-color: ${(props) => props.theme.darkest_grey};
        color: ${(props) => props.theme.text};
    }

    .side_bar_menu_item:hover p {
        color: ${(props) => props.theme.text};
    }

    .side_bar_menu_item_text p {
        color: ${(props) => props.theme.darkest_grey}
    }

    .side_bar_menu_item.active {
        background-color: ${(props) => props.theme.darker_grey};
    }

    .side_bar_menu_item.active p {
        color: ${(props) => props.theme.text};
    }

    .back_button, .bell_icon, .button_rounded_square {
        color: ${(props) => props.theme.text};
        background-color: ${(props) => props.theme.auth_body};
    }

    .back_button:hover, .bell_icon:hover, .button_rounded_square {
        color: ${(props) => props.theme.text} !important;
        background-color: ${(props) => props.theme.darker_grey} !important;
        transition: background-color 0.5s ease;
        border: 1px solid ${(props) => props.theme.transparent} !important;
    }

    .back_button:active, .bell_icon:active, .button_rounded_square {
        background-color: ${(props) => props.theme.darkest_grey};
        transition: background-color 0.5s ease;
    }

    .back_button:focus, .bell_icon:focus, .button_rounded_square {
        background-color: ${(props) => props.theme.darkest_grey};
        transition: background-color 0.5s ease;
    }

    .back_button:disabled, .bell_icon:disabled, .button_rounded_square {
        background-color: ${(props) => props.theme.auth_body};
        transition: background-color 0.5s ease;
    }

    .search_bar_wrapper {
        background-color: ${(props) => props.theme.auth_body};
    }

    .album_card {
        background-color: ${(props) => props.theme.auth_body};
    }

    .album_card img {
        width: 200px;
    }

    .album_card h3 {
        color: ${(props) => props.theme.border}
    }

    .album_card p {
        color: ${(props) => props.theme.border}
    }

    .community_card {
        background-color: ${(props) => props.theme.auth_body};
    
    }
    
    .contribution_list_item {
        background-color: ${(props) => props.theme.darker_grey};
    }
    
    .song_section_item:hover {
        color: ${(props) => props.theme.text};
        opacity: 1;
    }
`;

export const lightTheme = {
    body: WHITE,
    auth_body: LIGHT_GREY,
    text: BLACK,
    background: WHITE,
    light_grey: MINE_SHAFT,
    border: DARK_GREY,
    input_background: MECURY,
    primary_color: ORANGE,
    secondary_color: ORANGE_PEEL,
    tertiary_color: SINOPIA,
    quaternary_color: CHILEAN_FIRE,
    darkest_grey: DARKEST_GREY,
    darker_grey: DARKER_GREY,
    transparent: 'transparent',
};

export const darkTheme = {
    body: BLACK,
    auth_body: ORANGE_BLACK,
    text: WHITE,
    background: BLACK,
    light_grey: LIGHT_GREY,
    border: MECURY,
    input_background: MINE_SHAFT,
    primary_color: ORANGE,
    secondary_color: ORANGE_PEEL,
    tertiary_color: SINOPIA,
    quaternary_color: CHILEAN_FIRE,
    darkest_grey: DARKEST_GREY,
    darker_grey: DARKER_GREY,
    transparent: 'transparent',
};
